import React from 'react'
import Loadable from 'react-loadable'
// Routes that render the `Chrome` should use `RouteLoader`, other routes may use `FullPageLoader`
import RouteLoader from '#src/components/RouteLoader'
import { FullPageLoader } from '@deal/components'

export const About = Loadable({
  loader: () => import(/* webpackChunkName: "about" */ '#src/routes/about'),
  loading: () => <RouteLoader isDepartmentSpecificPage={false} />
})
export const Account = Loadable({
  loader: () => import(/* webpackChunkName: "account" */ '#src/routes/account'),
  loading: () => <RouteLoader />
})
export const Apply = Loadable({
  loader: () => import(/* webpackChunkName: "apply" */ '#src/routes/apply'),
  loading: () => <RouteLoader />
})
export const Auth = Loadable({
  loader: () => import(/* webpackChunkName: "auth" */ '#src/routes/auth'),
  loading: () => <RouteLoader />
})
export const Careers = Loadable({
  loader: () => import(/* webpackChunkName: "careers" */ '#src/routes/careers'),
  loading: () => <RouteLoader isDepartmentSpecificPage={false} />
})
export const Categories = Loadable({
  loader: () => import(/* webpackChunkName: "categories" */ '#src/routes/categories'),
  loading: () => <RouteLoader />
})
export const Curations = Loadable({
  loader: () => import(/* webpackChunkName: "curations" */ '#src/routes/curations'),
  loading: () => <RouteLoader />
})
export const Departments = Loadable({
  loader: () => import(/* webpackChunkName: "departments" */ '#src/routes/departments'),
  loading: () => <RouteLoader />
})
export const Experts = Loadable({
  loader: () => import(/* webpackChunkName: "expert" */ '#src/routes/experts'),
  loading: () => <RouteLoader />
})
export const FAQ = Loadable({
  loader: () => import(/* webpackChunkName: "faq" */ '#src/routes/faq'),
  loading: () => <RouteLoader isDepartmentSpecificPage={false} />
})
export const Feedback = Loadable({
  loader: () => import(/* webpackChunkName: "feedback" */ '#src/routes/feedback'),
  loading: () => <RouteLoader />
})
export const Favorites = Loadable({
  loader: () => import(/* webpackChunkName: "favorites" */ '#src/routes/favorites'),
  loading: () => <RouteLoader />
})
export const GuestCheckout = Loadable({
  loader: () => import(/* webpackChunkName: "guest-checkout" */ '#src/routes/guest-checkout'),
  loading: () => <RouteLoader isDepartmentSpecificPage={false} />
})
export const Home = Loadable({
  loader: () => import(/* webpackChunkName: "home" */ '#src/routes/home'),
  loading: () => <RouteLoader isDepartmentSpecificPage={false} />
})
export const HowItWorks = Loadable({
  loader: () => import(/* webpackChunkName: "how-it-works" */ '#src/routes/how-it-works'),
  loading: () => <RouteLoader isDepartmentSpecificPage={false} />
})
export const InAction = Loadable({
  loader: () => import(/* webpackChunkName: "in-action" */ '#src/routes/in-action'),
  loading: () => <RouteLoader />
})
export const Inbox = Loadable({
  loader: () => import(/* webpackChunkName: "inbox" */ '#src/routes/inbox'),
  loading: () => <RouteLoader />
})
export const Journal = Loadable({
  loader: () => import(/* webpackChunkName: "journal" */ '#src/routes/journal'),
  loading: () => <RouteLoader />
})
export const Landing = Loadable({
  loader: () => import(/* webpackChunkName: "landing" */ '#src/routes/landing'),
  loading: () => <FullPageLoader />
})
export const Legal = Loadable({
  loader: () => import(/* webpackChunkName: "legal" */ '#src/routes/legal'),
  loading: () => <RouteLoader isDepartmentSpecificPage={false} />
})
export const Giveaways = Loadable({
  loader: () => import(/* webpackChunkName: "giveaways" */ '#src/routes/giveaways'),
  loading: () => <RouteLoader isDepartmentSpecificPage={false} />
})
export const GoodbyeCharters = Loadable({
  loader: () =>
    import(/* webpackChunkName: "goodbye-charters" */ '#src/components/YachtsGoodbyeLandingPage'),
  loading: () => <RouteLoader />
})
export const MeetTheExperts = Loadable({
  loader: () => import(/* webpackChunkName: "meet-the-experts" */ '#src/routes/meet-the-experts'),
  loading: () => <RouteLoader isDepartmentSpecificPage={false} />
})
export const MostRecommended = Loadable({
  loader: () => import(/* webpackChunkName: "most-recommended" */ '#src/routes/most-recommended'),
  loading: () => <RouteLoader />
})
export const Checkout = Loadable({
  loader: () => import(/* webpackChunkName: "checkout" */ '#src/routes/checkout'),
  loading: () => <RouteLoader />
})
export const Orders = Loadable({
  loader: () => import(/* webpackChunkName: "orders" */ '#src/routes/orders'),
  loading: () => <RouteLoader />
})
export const GiftCards = Loadable({
  loader: () => import(/* webpackChunkName: "gift-cards" */ '#src/routes/gift-cards'),
  loading: () => <RouteLoader />
})
export const OrganicReferralSignup = Loadable({
  loader: () =>
    import(/* webpackChunkName: "organic-referral-signup" */ '#src/routes/organic-referral-signup'),
  loading: () => <FullPageLoader />
})
export const Path = Loadable({
  loader: () => import(/* webpackChunkName: "path" */ '#src/routes/path'),
  loading: () => <RouteLoader />
})
export const Products = Loadable({
  loader: () => import(/* webpackChunkName: "products" */ '#src/routes/products'),
  loading: () => <RouteLoader />
})
export const PromotionalSearch = Loadable({
  loader: () =>
    import(/* webpackChunkName: "promotional-search" */ '#src/routes/promotional-search'),
  loading: () => <RouteLoader />
})
export const Redirects = Loadable({
  loader: () => import(/* webpackChunkName: "redirects" */ '#src/routes/redirects'),
  loading: () => <RouteLoader />
})
export const Requests = Loadable({
  loader: () => import(/* webpackChunkName: "requests" */ '#src/routes/requests'),
  loading: () => <FullPageLoader />
})
export const Referral = Loadable({
  loader: () => import(/* webpackChunkName: "referral" */ '#src/routes/referral'),
  loading: () => <FullPageLoader />
})
export const ReferAFriend = Loadable({
  loader: () => import(/* webpackChunkName: "refer-a-friend" */ '#src/routes/refer-a-friend'),
  loading: () => <RouteLoader />
})
export const Returns = Loadable({
  loader: () => import(/* webpackChunkName: "returns" */ '#src/routes/returns'),
  loading: () => <RouteLoader isDepartmentSpecificPage={false} />
})
export const Reviews = Loadable({
  loader: () => import(/* webpackChunkName: "reviews" */ '#src/routes/reviews'),
  loading: () => <RouteLoader isDepartmentSpecificPage={false} />
})
export const Sellable = Loadable({
  loader: () => import(/* webpackChunkName: "sellable" */ '#src/routes/sellable'),
  loading: () => <RouteLoader />
})
export const SmsPromo = Loadable({
  loader: () => import(/* webpackChunkName: "sms-promo" */ '#src/routes/sms-promo'),
  loading: () => <RouteLoader />
})
export const Support = Loadable({
  loader: () => import(/* webpackChunkName: "support" */ '#src/routes/support'),
  loading: () => <RouteLoader isDepartmentSpecificPage={false} />
})
export const Team = Loadable({
  loader: () => import(/* webpackChunkName: "team" */ '#src/routes/team'),
  loading: () => <RouteLoader isDepartmentSpecificPage={false} />
})
